/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Agent_Passkey_Revoke_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not revoke the passkey" |
*
* @param {Profile_Security_Agent_Passkey_Revoke_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkey_revoke_error = /** @type {((inputs?: Profile_Security_Agent_Passkey_Revoke_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_Passkey_Revoke_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey konnte nicht widerrufen werden")
	return /** @type {LocalizedString} */ ("Could not revoke the passkey")
});